import { useLang } from '@/i18n';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';

export default function useProductList(locale: string) {
    const { t } = useLang('Emergency');
    const usProductMultiDay = [
        {
            img: '',
            title: t('Multi_item_1_title'),
            desc: t('Multi_item_1_desc'),
            label: t('Multi_item_1_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15391292588105',
                };
                return localMap[locale];
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54714781171785',
                };
                return localMap[locale];
            })(),
            link_more: `https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781171785`,
            type: 'Multi-Day',
        },
        {
            img: '',
            title: t('Multi_item_2_title'),
            desc: t('Multi_item_2_desc'),
            label: t('Multi_item_2_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15391292588105',
                };
                return localMap[locale];
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54714781204553',
                };
                return localMap[locale];
            })(),
            link_more: `https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781204553`,
            type: 'Multi-Day',
        },
        {
            img: '',
            title: t('Multi_item_3_title'),
            desc: t('Multi_item_3_desc'),
            label: t('Multi_item_3_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15391292588105',
                };
                return localMap[locale];
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54714781237321',
                };
                return localMap[locale];
            })(),
            link_more: `https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781237321`,
            type: 'Multi-Day',
        },
    ];
    const usProductListHours = [
        {
            img: '',
            title: t('hours_item_1_title'),
            desc: t('hours_item_1_desc'),
            label: t('hours_item_1_label'),
            productId: (() => {
                const localMap: any = {
                    us: '7290968473673',
                    ca: '8335910928538',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41636504305737',
                    ca: '45166394409114',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/river-3-portable-power-station`,
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_2_title'),
            desc: t('hours_item_2_desc'),
            label: t('hours_item_2_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41636514136137',
                    ca: '52355185279347',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/river-3-plus-portable-power-station`,
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_5_title'),
            desc: t('hours_item_5_desc'),
            label: t('hours_item_5_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15386067730505',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54691871227977',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: `https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977`,
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_4_title'),
            desc: t('hours_item_4_desc'),
            label: t('hours_item_4_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41826182496329',
                    ca: '45161302229146',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329'
                    : 'https://ca.ecoflow.com/products/delta-3-1500-portable-power-station',
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_3_title'),
            desc: t('hours_item_3_desc'),
            label: t('hours_item_3_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '42015827492937',
                    ca: '51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-3-portable-power-station?variant=42015827492937'
                    : 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station',
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_6_title'),
            desc: t('hours_item_6_desc'),
            label: t('hours_item_6_label'),
            productId: (() => {
                const localMap: any = {
                    us: '7323318190153',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41719074324553',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: 'https://us.ecoflow.com/products/delta-2-portable-power-station?variant=41719074324553',
            type: 'hours',
        },
    ];
    const caProductListHours = [
        {
            img: '',
            title: t('hours_item_2_title'),
            desc: t('hours_item_2_desc'),
            label: t('hours_item_2_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41636514136137',
                    ca: '52355185279347',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/river-3-plus-portable-power-station`,
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_5_title'),
            desc: t('hours_item_5_desc'),
            label: t('hours_item_5_label'),
            productId: (() => {
                const localMap: any = {
                    ca: '15164532916595',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '62060639584627',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: `https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627`,
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_3_title'),
            desc: t('hours_item_3_desc'),
            label: t('hours_item_3_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '42015827492937',
                    ca: '51645140926835',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-3-portable-power-station?variant=42015827492937'
                    : 'https://ca.ecoflow.com/products/delta-3-plus-portable-power-station',
            type: 'hours',
        },
        {
            img: '',
            title: t('hours_item_4_title'),
            desc: t('hours_item_4_desc'),
            label: t('hours_item_4_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41826182496329',
                    ca: '45161302229146',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-3-plus-portable-power-station?variant=41826182496329'
                    : 'https://ca.ecoflow.com/products/delta-3-1500-portable-power-station',
            type: 'hours',
        },
    ];

    const productListHours = locale === 'us' ? usProductListHours : caProductListHours;
    const productListMultiDay = locale === 'us' ? usProductMultiDay : [];

    const usProductList4Days = [
        {
            img: '',
            title: t('4_days_item_5_title'),
            desc: t('4_days_item_5_desc'),
            label: t('4_days_item_5_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15386147061833',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718699962441',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_1_title'),
            desc: t('4_days_item_1_desc'),
            label: t('4_days_item_1_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-2-max-portable-power-station'
                    : 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_6_title'),
            desc: t('4_days_item_6_desc'),
            label: t('4_days_item_6_label'),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718705008713',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_2_title'),
            desc: t('4_days_item_2_desc'),
            label: t('4_days_item_2_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-pro-portable-power-station'
                    : 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_3_title'),
            desc: t('4_days_item_3_desc'),
            label: t('4_days_item_3_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station'
                    : 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_4_title'),
            desc: t('4_days_item_4_desc'),
            label: t('4_days_item_4_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41963472289865',
                    ca: '44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865'
                    : 'https://ca.ecoflow.com/products/delta-pro-ultra',
            type: '4_days',
        },
    ];
    const caProductList4Days = [
        {
            img: '',
            title: t('4_days_item_5_title'),
            desc: t('4_days_item_5_desc'),
            label: t('4_days_item_5_label'),
            productId: (() => {
                const localMap: any = {
                    ca: '15164532654451',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '62060638372211',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_6_title'),
            desc: t('4_days_item_6_desc'),
            label: t('4_days_item_6_label'),
            productId: (() => {
                const localMap: any = {
                    ca: '15164531016051',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_3_title'),
            desc: t('4_days_item_3_desc'),
            label: t('4_days_item_3_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station'
                    : 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
            type: '4_days',
        },
        {
            img: '',
            title: t('4_days_item_4_title'),
            desc: t('4_days_item_4_desc'),
            label: t('4_days_item_4_label'),
            variantId: (() => {
                const localMap: any = {
                    us: '41963472289865',
                    ca: '44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            link_more:
                locale === 'us'
                    ? 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865'
                    : 'https://ca.ecoflow.com/products/delta-pro-ultra',
            type: '4_days',
        },
    ];

    const productList4Days = locale === 'us' ? usProductList4Days : caProductList4Days;

    const [productList, setProductList] = useState(
        [
            ...productListMultiDay,
            {
                img: '',
                title: t('5_days_item_4_title'),
                desc: t('5_days_item_4_desc'),
                label: t('5_days_item_4_label'),
                variantId: (() => {
                    const localMap: any = {
                        ca: '62111365792115',
                    };
                    return localMap[locale];
                })(),
                type: '5_days',
                link_more: `https://ca.ecoflow.com/products/delta-pro-ultra-x?variant=62111365792115`,
            },
            {
                img: '',
                title: t('5_days_item_1_title'),
                desc: t('5_days_item_1_desc'),
                label: t('5_days_item_1_label'),
                variantId: (() => {
                    const localMap: any = {
                        us: '41703627980873',
                        ca: '52644324901235',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                type: '5_days',
                link_more:
                    locale === 'us'
                        ? 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41703627980873'
                        : 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=52644324901235',
            },
            {
                img: '',
                title: t('5_days_item_2_title'),
                desc: t('5_days_item_2_desc'),
                label: t('5_days_item_2_label'),
                variantId: (() => {
                    const localMap: any = {
                        us: '54341604376649',
                        // ca: '52476795552115',
                    };
                    return localMap[locale];
                })(),
                type: '5_days',
                link_more:
                    locale === 'us'
                        ? 'https://us.ecoflow.com/products/ecoflow-delta-pro-3-smart-generator-4000-transfer-switch'
                        : 'https://ca.ecoflow.com/products/delta-pro-3-smart-generator-4000-transfer-switch',
            },
            {
                img: '',
                title: t('5_days_item_3_title'),
                desc: t('5_days_item_3_desc'),
                label: t('5_days_item_3_label'),
                variantId: (() => {
                    const localMap: any = {
                        us: '54404262101065',
                        ca: '52608974455155',
                    };
                    return localMap[locale] || localMap.us;
                })(),
                type: '5_days',
                link_more:
                    locale === 'us'
                        ? 'https://us.ecoflow.com/products/delta-pro-ultra-extra-battery-smart-home-panel-2?variant=54404262101065'
                        : 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=52608974455155',
            },
            ...productList4Days,
            ...productListHours,
        ].filter((i) => i.variantId),
    );

    useEffect(() => {
        getItemInfo();
    }, [locale]);

    async function getItemInfo() {
        const variantIds = productList.map((item) => item.variantId);
        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            const newItems = cloneDeep(productList);
            res.data.forEach((item: any) => {
                const newItem = newItems.find((_item) => _item.variantId === item.variantId);
                if (newItem) {
                    newItem.img = item.variantImg;
                    // @ts-expect-error
                    newItem.price = item.price;
                    // @ts-expect-error
                    newItem.discountPrice = item.discountPrice;
                    // @ts-expect-error
                    newItem.skuTitle = item.skuTitle;
                    // @ts-expect-error
                    newItem.quantity = item.quantity;
                    // if (newItem.type === 'Multi-Day') {
                    //     newItem.title = item.skuTitle;
                    // }
                }
            });

            setProductList(newItems);
        }
    }

    return { productList, setProductList };
}
